import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { PATIENT_DEBIT_REPORT } from "../../graphql/queries/Providers";

/**
 * Loads the patients with an updated virtual debit number for the logged-in provider.
 *
 * @param {{fromdate: string, todate: string}} props the owning component's props
 */
export default function usePatientDebitReport(props) {
    const provider_id = parseInt(window.localStorage.getItem("providerID"));

    const [loadReport, { data }] = useLazyQuery(PATIENT_DEBIT_REPORT, {
        variables: {
            provider_id,
            debit_updated_from: props.fromdate ? props.fromdate : null,
            debit_updated_to: props.todate ? props.todate : null,
        },
    });

    useEffect(() => {
        loadReport();
    }, [props]);

    return data;
}

